import * as React from "react";
import {Loading} from "web-com";
import {useEffect, useState} from "react";
import {getInstitutions} from "IncompleteInfoV2/BankStatementV2/BankSelection/api";
import SelectBank, {IBankOptions} from "IncompleteInfoV2/BankStatementV2/BankSelection/SelectDropdown";
import {IBankDetails} from "IncompleteInfoV2/BankStatementV2";

interface IProps {
    disabled: boolean;
    onChangeHandler: (id: string, name: string, isNetBanking: boolean) => void;
    bankDetails?: IBankDetails;
}

const BankSelection = (props: IProps) => {
    const [loading, setLoading] = useState(false);
    const [bankList, setBankList] = useState<IBankOptions[] | []>([]);
    useEffect(() => {
        (async () => {
            setLoading(true);
            const res = await getInstitutions();
            const bankOptions = res.map((data) => {
                return {
                    name: data.name,
                    value: data.id,
                    isNetBanking: data.netbankingAllowed,
                };
            });
            setBankList([
                {name: "Select bank name", value: "", isDisabled: true, isNetBanking: false},
                ...bankOptions,
            ]);
            setLoading(false);
        })();
    }, []);
    return(
        <div>
            <Loading active={loading}/>
            {bankList.length &&
                <SelectBank
                  bankDetails={props.bankDetails}
                  options={bankList}
                  disabled={props.disabled}
                  onBankSelect={(id, name, isNetBanking) => props.onChangeHandler(id , name, isNetBanking)}
                />
            }
        </div>
    );
};

export default BankSelection;
